export default __webpack_public_path__ + "static/media/card-product3.068b9428.jpg";